import SvgContainer from "../SvgContainer";

function SvgEncircledMinus( { width, height, color = "#040404", ...remProps } ){
    return(
        <SvgContainer { ...remProps }
        width = { width }
        height = { height }
        fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M15.5552 12.0007H8.44412M22.6663 12.0007C22.6663 17.8917 17.8907 22.6673 11.9997 22.6673C6.10864 22.6673 1.33301 17.8917 1.33301 12.0007C1.33301 6.10961 6.10864 1.33398 11.9997 1.33398C17.8907 1.33398 22.6663 6.10961 22.6663 12.0007Z" stroke={color} stroke-width="1.77778" stroke-linecap="round" stroke-linejoin="round"/>
        </SvgContainer>
    )
}

export default SvgEncircledMinus;